module.exports = __webpack_public_path__ + "assets/img/greenestImg4.01bd191b.png";